import { render, staticRenderFns } from "./CalcButton.vue?vue&type=template&id=a637be8e"
import script from "./CalcButton.vue?vue&type=script&lang=js"
export * from "./CalcButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports